export default {
  guests_pay: 'Gasten betalen {{amount}} bij het afrekenen (laatste wisselkoers).',
  missing_rate: 'Nog geen wisselkoers voor {{currency}}, dus gasten betalen {{amount}} onomgezet.',
};
